import { createFileRoute, redirect } from '@tanstack/react-router';

/** Removed from catalog POC — keep stub so stale routeTree regenerations don't break. */
export const Route = createFileRoute('/solutions_/$slug')({
  beforeLoad: () => {
    throw redirect({ to: '/', replace: true });
  },
});
